import ARGENT_WALLET_DETECTOR_ABI from './argent-wallet-detector.json';

const ARGENT_WALLET_DETECTOR_MAINNET_ADDRESS =
  '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8';

export { ARGENT_WALLET_DETECTOR_ABI, ARGENT_WALLET_DETECTOR_MAINNET_ADDRESS };
